import Modal from 'react-bootstrap/Modal';
import { type NotificationDto } from '@/app/models/NotificationDto';
import DailySummarySections from '../components/DailySummarySections';

type DailySummaryModalProps = {
  show: boolean;
  onClose: () => void;
  notification?: NotificationDto;
};

const DailySummaryModal = ({ show, onClose, notification }: DailySummaryModalProps) => (
  <Modal scrollable show={show} onHide={onClose}>
    <Modal.Header closeButton>
      <Modal.Title>{notification?.title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <DailySummarySections sections={notification?.summary ?? []} onNavigate={onClose} />
    </Modal.Body>
  </Modal>
);

export default DailySummaryModal;
